import { motion } from "framer-motion";
import { Instagram, Facebook, ArrowUpRight } from "lucide-react";

const CARDS = [
  {
    platform: "Instagram",
    handle: "@StudExchangeOfficial",
    url: "https://instagram.com/StudExchangeOfficial",
    note: "Daily minifigure breakdowns, vault unboxings & rare drop alerts",
    Icon: Instagram,
    testId: "instagram-link",
  },
  {
    platform: "Facebook",
    handle: "Stud Exchange Official",
    url: "https://facebook.com/StudExchangeOfficial",
    note: "Community showcases, trade nights & collector discussions",
    Icon: Facebook,
    testId: "facebook-link",
  },
];

export default function Socials() {
  return (
    <section id="socials" className="bg-[#121110] text-[#F3EDE3] py-24 md:py-32" data-testid="socials-section">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="font-mono text-xs uppercase tracking-[0.35em] gold-text flex items-center gap-3">
            <span className="inline-block w-10 h-px bg-[#B38728]" /> 06 — The Collector Community
          </p>
          <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl tracking-tight mt-5 max-w-2xl">
            Daily drops. <span className="italic gold-text">Rare finds.</span> Zero boring posts.
          </h2>
        </motion.div>

        <div className="mt-14 grid md:grid-cols-2 gap-6">
          {CARDS.map((c, i) => (
            <motion.a
              key={c.platform}
              href={c.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={c.testId}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.15, ease: [0.16, 1, 0.3, 1] }}
              className="group border border-[#3a372f] p-10 hover:border-[#D4AF37] transition-colors duration-500 flex flex-col min-h-[16rem]"
            >
              <div className="flex items-start justify-between">
                <c.Icon className="w-8 h-8 text-[#D4AF37]" />
                <ArrowUpRight className="w-6 h-6 text-[#5C564C] group-hover:text-[#D4AF37] group-hover:translate-x-1 group-hover:-translate-y-1 transition-all" />
              </div>
              <div className="mt-auto">
                <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#a79f90]">{c.platform}</p>
                <p className="font-serif text-2xl mt-2 group-hover:gold-text transition-all">{c.handle}</p>
                <p className="text-sm text-[#a79f90] mt-3">{c.note}</p>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
